import React, { Component } from 'react';
import TagManager from 'react-gtm-module';

import Logo from '../img/logo_white_full_lg_2025.png';

import PhoneIcon from '../img/phone.png';
import Facebook from '../img/facebook_f.png';
import Instagram from '../img/icons-2025/social-media/instagram-white.svg';
import Youtube from '../img/icons-2025/social-media/youtube-white.svg';

export default class GuestFrame extends Component {
	constructor(props){
		super(props);
		this.state={};
	}
	render() {
		return (
				<div className="guest-container">
					<div className="content">
						<GuestHeader />
						
						<div className="guest-content-columns-container" style={this.props.injectedStyles}>
							{this.props.children}
							
							<div className="guest-slogan" style={this.props.sloganInjectedStyles}>
								<h3>Sucursal Virtual</h3>
								<h1>Cuando la Pyme se levanta, todo Chile se levanta.</h1>
								<h2>Por ti, por las Pymes, por Chile.</h2>
							</div>
						</div>
				</div>
				<div className="veil"></div>
				<div className="background-photo"></div>
			</div>
		);
	}
}

class GuestHeader extends Component {
	sendCustomEventGTM({event, metadata={}}){
		if (!event) return; 
		TagManager.dataLayer({ 
			dataLayer:{ event, metadata } 
		});
	}
	render(){
		return(
			<div className="guest-header">
				<a href="/" onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_logo"})}>
					<img alt="ABASTIBLE" className="guest-logo" src={Logo} />
				</a>
				<div className="guest-header-info-back-container">
					<img alt="" src={PhoneIcon} className="guest-header-icon margin-right" />
					<a href='tel:800209000' className="guest-header-info margin-right" onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_pedidos"})}>
						Pedidos: <strong>800 20 9000</strong>
					</a>
					<a href='tel:800209000' className="guest-header-info margin-right" onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_emergencia"})}>
						Emergencia: <strong>800 20 9000</strong>
					</a>
					<div className="links-rrss-container">
						<a 
						className="link-rrss" 
						target="_blank" 
						href="https://facebook.com" 
						rel="noopener noreferrer" 
						onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_rrss", metadata:{socialNetwork:"facebook"}})}>
							<img alt="" src={Facebook} className="guest-header-icon margin-left" />
						</a>

						<a 
						className="link-rrss" 
						target="_blank" 
						href="https://instagram.com" 
						rel="noopener noreferrer" 
						onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_rrss", metadata:{socialNetwork:"instagram"}})}>
							<img alt="" src={Instagram} className="guest-header-icon margin-left" />
						</a>

						<a 
						className="link-rrss" 
						target="_blank" 
						href="https://youtube.com" 
						rel="noopener noreferrer" 
						onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_rrss", metadata:{socialNetwork:"youtube"}})}>
							<img alt="" src={Youtube} className="guest-header-icon margin-left" />
						</a>
					</div>
					<p className="guest-header-back">
						<a href="https://abastible.cl" onClick={()=>this.sendCustomEventGTM({event:"sv_login_click_ir_abastible"})}>
							Ir a Abastible.cl
						</a>
					</p>
				</div>
			</div>
		)
	}
}
